module.exports = __webpack_public_path__ + "img/icon-in-review.78939d9c.svg";